<template>
    <div>
        <h2 class="categories-h2">Wat wil je laten zandstralen?</h2>
        <div class="categories__group">
            <div class="row">
                <div v-for="category in categories" v-bind:key="category.id" class="col-6 col-sm-4 col-md-3 col-lg-2 category">
                    <router-link :to="{ name: 'products', params: { id: category.id }}" v-on:click.native="selectedCategory(category.id)" >
                        <img :src="'https://api.straalstudio.be/assets/images/icons/' + category.logo" :alt="category.name" class="img-fluid" >
                        <strong>{{ category.name }}</strong>
                    </router-link>
                </div >
            </div>
        </div>
    </div>
</template>

<script>
    import ajax from '../ajax';

    export default {
        name: "Categories",

        data() {
            return {
                id                  : this.$route.params.id,
                category_name       : this.$route.params.category_name,
                categories : []
            }
        },

        methods: {
            selectedCategory(id) {
                console.log(id);
                //this.$store.dispatch('category_id', this.id)
            }
        },

        mounted: function () {
            ajax.get('/api/v1/category')
                .then(response =>{
                    if(response.status == 200) {
                        this.categories = response.data
                    }
                })
                .catch(error =>{
                    console.log(error);
                })
        }
    }
</script>

<style scoped lang="scss">
    .categories-h2 {
        font-size: 1.7rem;
        margin-bottom: 20px;
        text-align: center;
        font-weight: 500;
        @media (min-width: 992px) {
            font-size: 2rem;
            text-align: left;
            margin-left: 15px;
        }
        @media (min-width: 1200px) {
            font-size: 2.4rem;
        }
    }
    .categories__group {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        /*flex: flex-basis flex-grow  flex-shrink; */
        a {
            transition: all .35s ease-in-out;
        }
        a:hover  {
            text-decoration: none;
            filter: brightness(0%);
            strong {
                filter: brightness(0%);
            }
        }
    }

    .category {
        padding: 20px 15px;
        border-radius: 3px;
        img {
            max-width: 75%;

        }
        @media (min-width: 992px)  {
            padding: 20px 15px;
            border-radius: 3px;
            margin-bottom: 15px;
            img {
                max-width: 85%;
            }
        }
        min-height: 100px;
        text-align: center;
        text-decoration: none;

        strong {
            color: white;
            display: block;
            margin-top: 15px;
            font-size: .85rem;
            text-transform: uppercase;
            transition: all .35s ease-in-out;
            @media (min-width: 992px) {
                font-size: .95rem;
            }
        }
    }

</style>